
import { Injectable } from '@angular/core';
import { NestApiProvider } from '../../shared/nestjs/nest-api';
import { ApprovalSettingApi } from '../../shared/nestjs/gd-only/services/approval-setting.api';
import { RequestGetApprovalSettingDto, RequestProcessReplaceOfApproveDto, ResponseGetApprovalSettingDto } from '../../shared/nestjs/gd-only/dto/approval-setting.dto';
import { Subscription } from 'rxjs';
import { ResponsePaging, ResponseData } from '../../shared/nestjs/nest-responses';

/*
  Generated class for the ChangePrivacyBloc provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

@Injectable()
export class ChangeApproverBloc {
	private subscriptions: Array<Subscription> = [];
	constructor(
		private approvalSettingApi: ApprovalSettingApi,
		public nestApiProvider: NestApiProvider
	) {

	}

	dispose() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}

	getApprovalReplace(payload: RequestGetApprovalSettingDto) {
		return new Promise<ResponsePaging<ResponseGetApprovalSettingDto>>((resolve, reject) => {
			this.subscriptions.push(
				this.approvalSettingApi.getApprovalReplace(payload)
					.subscribe((result) => {
						resolve(result);
					}, error => {
						reject(error)
					})
			)
		})
	}

	saveApprover(payload: Array<RequestProcessReplaceOfApproveDto>) {
		console.log('payload',payload);
		return new Promise<ResponseData<any>>((resolve, reject) => {
			this.subscriptions.push(
				this.approvalSettingApi.processReplaceOfApprove(payload)
					.subscribe((result) => {
						resolve(result);
					}, error => {
						reject(error)
					})
			)
		})
	}


}




// WEBPACK FOOTER //
// ./src/bloc/settings/change-approver.bloc.ts